package com.eladfinish.bible.contest.screens.search.mvi

import com.eladfinish.bible.contest.constants.SharedPrefsConstants
import com.russhwolf.settings.Settings

/**
 * The value of "נוסח הקרי בלבד" the Search screen starts with: the global setting that Browse,
 * the random verse and the special searches already follow, qere-only when it was never set.
 *
 * Search V2 (1ed4cbf06) started the screen with the box unchecked and never read the setting,
 * so a word that appears in both the ketiv and the qere of one verse (ישראל in שמואל ב י ט) was
 * counted twice, against the search guide and SearchGuideExamplesTest, which assume qere only.
 * The toolbar checkbox still overrides this for the screen; it does not write the setting back.
 */
internal fun initialOnlyQri(settings: Settings): Boolean =
    settings.getBoolean(key = SharedPrefsConstants.ONLY_QRI_SWITCH, defaultValue = true)
